import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpCommunity'

// Admin CRUD for the manual console price watchlist (Xbox/PSN/Nintendo) —
// web UI for what used to be CLI-only via
// game-prices:watch-{xbox,psn,nintendo} (see backend
// GamePriceWatchlistApiController).
export const getWatchlist = (
	params = {
		per_page: 10,
		page: 1,
		'filter[term]': '',
		'filter[provider]': '',
	},
) => Http.get(`/game-price-watchlist/fetch${serialize(params)}`)

export const saveWatchlistEntry = (
	params = {
		game_id: null,
		provider: null,
		external_id: null,
		external_title: null,
	},
) => Http.post(`/game-price-watchlist/store`, params)

export const updateWatchlistEntry = (
	params = {
		id: null,
		game_id: null,
		provider: null,
		external_id: null,
		external_title: null,
	},
) => Http.put(`/game-price-watchlist/${params.id}/update`, params)

export const deleteWatchlistEntry = (
	params = {
		id: null,
	},
) => Http.delete(`/game-price-watchlist/${params.id}/destroy`)

// Lightweight id/name/thumbnail_url search for the "add entry" game picker —
// distinct from games/fetch (used by @/@core/components/SelectGame.vue),
// which loads every admin relation and is too heavy for a simple dropdown.
export const searchGamesLight = term => Http.get(`/games/search?q=${encodeURIComponent(term)}`)
